export default __webpack_public_path__ + "static/media/DSC01086.381aafc7.jpg";